/**
 * i13n config
 *
 * setting page parameter on supplierCenter(dashboard) for it uses hash as page link
 * dimension mapping conf: https://git.vzbuilders.com/EC-Web/ec-react-i13n/blob/master/src/mappingConf.js
 * ref:
 * https://docs.google.com/spreadsheets/d/1KjZTQ3GndfAIQKJWendCBOlq3n_jJZqJMWk9rtLQi60/edit#gid=2145796675
*/
const _ = require('lodash')
const { PROPOSAL_TYPE, PROPOSAL_PHASE_TYPE } = require('@vzmi/shp_shared_compo/constants/proposal')

const extractGASupplierFromPage = page => {
  const { supplierId, supplierName } = _.get(page, 'user', {})
  return { cat1Name: `${supplierId}`, cat2Name: supplierName }
}

const i13nConf = {
  todo: {
    page: '/todo',
    documentGroup: 'supplierCenter',
    subType: 'center_todo'
  },
  shortcut: {
    page: '/shortcut',
    documentGroup: 'supplierCenter',
    subType: 'center_shortcut'
  },
  shortcutSetting: {
    page: '/shortcut',
    documentGroup: 'supplierCenter',
    subType: 'center_shortcutSetting'
  },
  dashboard: {
    page: '/dashboard',
    documentGroup: 'supplierCenter',
    subType: 'center_supplierDashboard',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  expiringItems: {
    documentGroup: 'warehouse',
    subType: 'wh_expiringItems',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  unsalableItems: {
    documentGroup: 'warehouse',
    subType: 'wh_unsalableItems',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  SecretDashboard: {
    documentGroup: 'OT',
    subType: '371_supplierDashboard',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  hourlysale_mobile: {
    page: '/m/dashboard',
    documentGroup: 'supplierCenter_mobile',
    subType: 'hourlysale_mobile',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  bestSelling: {
    documentGroup: 'topselling',
    subType: 'topsellinglist',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  searchKeywords: {
    documentGroup: 'topkeyword',
    subType: 'topkeywordlist',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  salesPerformance: {
    documentGroup: 'hourrank',
    subType: 'hourranklist',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  customerInterest_abandonedCart: {
    documentGroup: 'abandonedcart',
    subType: 'abandonedcartlist',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  customerInterest_arrivalNotice: {
    documentGroup: 'arrivalnotice',
    subType: 'arrivalnoticelist',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  customerInterest_favoriteProduct: {
    documentGroup: 'favoriteproduct',
    subType: 'favoriteproductlist',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  },
  externalClone: {
    documentGroup: 'newListing',
    subType: 'externalClone',
    dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
  }
}

const getProposalI13nConf = (proposalTypeList, phaseList, proposalTypeSuffix = '') => {
  const conf = proposalTypeList
    .reduce((accConf, curProposalType) => {
      phaseList.forEach(phase => {
        let page = `${curProposalType}-${phase}`
        let proposalType = curProposalType
        if (!_.isEmpty(proposalTypeSuffix)) {
          page = `${page}-${proposalTypeSuffix}`
          proposalType = `${proposalType}-${proposalTypeSuffix}`
        }

        _.set(accConf, page, {
          page,
          subType: page,
          documentGroup: 'proposal',
          dimension1: proposalType,
          dynamicDataCallback: ({ page }) => extractGASupplierFromPage(page)
        })
      })

      return accConf
    }, {})

  return conf
}

const newProposalI13nConf = getProposalI13nConf([
  PROPOSAL_TYPE.NEW_LISTING,
  PROPOSAL_TYPE.NEW_PRODUCT
],
[
  PROPOSAL_PHASE_TYPE.COMPOSE,
  PROPOSAL_PHASE_TYPE.OVERVIEW,
  PROPOSAL_PHASE_TYPE.CLONE,
  PROPOSAL_TYPE.CLONE_LISTING,
  'edit',
  'confirm',
  'success',
  'preview'
])

const updateListingProposalI13nConf = getProposalI13nConf([
  PROPOSAL_TYPE.UPDATE_COPY,
  PROPOSAL_TYPE.UPDATE_VIDEO,
  PROPOSAL_TYPE.UPDATE_IMAGE,
  PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
  PROPOSAL_TYPE.UPDATE_LISTING_MODEL,
  PROPOSAL_TYPE.UPDATE_LISTING
],
[
  PROPOSAL_PHASE_TYPE.COMPOSE,
  'confirm',
  'success',
  'preview'
])

const batchUpdateListingProposalI13nConf = getProposalI13nConf([
  PROPOSAL_TYPE.UPDATE_COPY,
  PROPOSAL_TYPE.UPDATE_VIDEO,
  PROPOSAL_TYPE.UPDATE_IMAGE,
  PROPOSAL_TYPE.UPDATE_ATTRIBUTE,
  PROPOSAL_TYPE.UPDATE_LISTING_MODEL,
  'coupon'
],
[
  PROPOSAL_PHASE_TYPE.COMPOSE,
  'confirm',
  'success',
  'preview'
],
'batch')

const batchUploadI13nConf = getProposalI13nConf([
  PROPOSAL_TYPE.UPDATE_IMAGE
],
[
  PROPOSAL_PHASE_TYPE.COMPOSE,
  'confirm',
  'success'
],
'batchUpload')

const exporter = {
  i13nConf,
  newProposalI13nConf,
  updateListingProposalI13nConf,
  batchUpdateListingProposalI13nConf,
  batchUploadI13nConf
}

module.exports = exporter
